function generate(params) {
    params.carI = 0;
    let output = {
        time_steps: params.timeSteps,
        junctions: [],
        roads: [],
        cars: []
    };

    for (let x = 0; x < params.gridWidth; x++) {
        for (let y = 0; y < params.gridHeight; y++) {
            const junction = {
                id: y * params.gridWidth + x,
                x: x * params.gridSize,
                y: y * params.gridSize,
                signals: []
            };

            for (let i = 0; i < 4; i++) {
                junction.signals.push({
                    dir: i,
                    time: getNumberInRange(params['signalTimeMin'], params['signalTimeMax'], true)
                })
            }

            output.junctions.push(junction);

            if (x < params.gridWidth - 1) {
                // If not on right edge, connect one street to junction below and one street to junction to the right
                const lanes = getNumberInRange(params['lanesPerRoadMin'], params['lanesPerRoadMax'], true);
                output.roads.push({
                    junction1: y * params.gridWidth + x,
                    junction2: y * params.gridWidth + x + 1,
                    lanes: lanes,
                    limit: getNumberInRange(params['limitMin'], params['limitMax'], true)
                });
                generateCars(params, car => output.cars.push(car), y * params.gridWidth + x, y * params.gridWidth + x + 1, lanes);
                generateCars(params, car => output.cars.push(car), y * params.gridWidth + x + 1, y * params.gridWidth + x, lanes);
            }
            if (y < params.gridHeight - 1) {
                // If not on bottom edge, connect one street to junction below and one street to junction to the right
                const lanes = getNumberInRange(params['lanesPerRoadMin'], params['lanesPerRoadMax'], true);
                output.roads.push({
                    junction1: y * params.gridWidth + x,
                    junction2: y * params.gridWidth + x + params.gridWidth,
                    lanes: lanes,
                    limit: getNumberInRange(params['limitMin'], params['limitMax'], true)
                });
                generateCars(params, car => output.cars.push(car), y * params.gridWidth + x, y * params.gridWidth + x + params.gridWidth, lanes);
                generateCars(params, car => output.cars.push(car), y * params.gridWidth + x + params.gridWidth, y * params.gridWidth + x, lanes);
            }
        }
    }

    return output;
}

function generateCars(params, add, from, to, lanes) {
    for (let i = 0; i < getNumberInRange(params['carsPerRoadMin'], params['carsPerRoadMax'], true); i++) {
        const route = [];
        for (let j = 0; j < getNumberInRange(params['routeLengthMin'], params['routeLengthMax'], true); j++) {
            route.push(getNumberInRange(0, 3, true));
        }

        add({
            id: params.carI++,
            target_velocity: getNumberInRange(params['targetVelocityMin'], params['targetVelocityMax'], true),
            max_acceleration: getNumberInRange(params['maxAccelerationMin'], params['maxAccelerationMax'], true),
            target_deceleration: getNumberInRange(params['targetDecelerationMin'], params['targetDecelerationMax'], true),
            min_distance: getNumberInRange(params['minDistanceMin'], params['minDistanceMax'], true),
            target_headway: getNumberInRange(params['targetHeadwayMin'], params['targetHeadwayMax'], true),
            politeness: getNumberInRange(params['politenessMin'], params['politenessMax'], false),
            start: {
                from, to,
                lane: getNumberInRange(0, lanes - 1, true),
                distance: getNumberInRange(0, params.gridSize * 100 - 35 / 2, false)
            },
            route
        });
    }
}


function getNumberInRange(min, max, round) {
    if (round) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    } else {
        return Math.random() * (max - min) + min;
    }
}

module.exports = {generate, getNumberInRange};